import type { AxiosResponse } from "axios";

import { getData } from "@/apis/apiInstance";

import type { InvoicingInsightsPayload } from "@/commonTypes/insightsTypes";

export async function getInvoicingRevenueInsightsApi(
  data: InvoicingInsightsPayload
): Promise<AxiosResponse> {
  const { start_date, end_date, client_code, token } = data;

  return await getData(`reports/invoice-value`, {
    params: {
      start_date,
      end_date,
      client_code,
      type: "revenue",
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getInvoicingExpensesInsightsApi(
  data: InvoicingInsightsPayload
): Promise<AxiosResponse> {
  const { start_date, end_date, client_code, token } = data;

  return await getData(`reports/invoice-value`, {
    params: {
      start_date,
      end_date,
      client_code,
      type: "expenses",
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
